import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">Zambagarrah</h1>
            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>
                <li>
                    <a href="#testimonial" className="footer__link">Testimonials</a>
                </li>
            </ul>
            <div className="footer__social">
                <a 
                    href="https://www.facebook.com/" 
                    className='footer__social-link' 
                    // target='_blank'
                >
                    <i class="bx bxs-phone"></i>
                </a>
                <a 
                    href="https://www.instagram.com/" 
                    className='footer__social-link' 
                    // target='_blank'
                >
                    <i class="bx bxs-message"></i>
                </a>
                <a 
                    href="https://api.whatsapp.com/send?phone=254705959986&text=Hello%2C%20I%27m%20just%20from%20your%20website%2C%20I%27d%20like%20us%20to%20have%20a%20chat." 
                    className='footer__social-link' 
                    // target='_blank'
                >
                    <i class='bx bxl-whatsapp'></i>
                </a>
            </div>
            <span className="footer__copy">
                &#169; Zambagarrah.Z.O. All Rights Reserved
            </span>
        </div>
    </footer>
  );
};

export default Footer;
